import LOGO_CJ_FOOD from '../assets/img/logo/partner_1.png'
import LOGO_ENERCON from '../assets/img/logo/partner_2.png'
import LOGO_FUJI_FILM from '../assets/img/logo/partner_3.png'
import LOGO_PERSONIFY from '../assets/img/logo/partner_4.png'
import LOGO_TECHBASE from '../assets/img/logo/partner_5.png'
import LOGO_HUBBLE from '../assets/img/logo/partner_6.png'
import LOGO_LIFULL from '../assets/img/logo/partner_7.png'
import LOGO_TRANSCOSMOS from '../assets/img/logo/partner_8.png'
import LOGO_YOSHINO from '../assets/img/logo/partner_9.png'
import LOGO_KEGNEL from '../assets/img/logo/partner_10.png'
import LOGO_SHIFT_ASIA from '../assets/img/logo/partner_11.png'
import LOGO_KAO from '../assets/img/logo/partner_12.png'

export const listPartnerFixture = [
  {
    id: 1,
    logo: LOGO_CJ_FOOD
  },
  {
    id: 2,
    logo: LOGO_ENERCON
  },
  {
    id: 3,
    logo: LOGO_FUJI_FILM
  },
  {
    id: 4,
    logo: LOGO_PERSONIFY
  },
  {
    id: 5,
    logo: LOGO_TECHBASE
  },
  {
    id: 6,
    logo: LOGO_HUBBLE
  },
  {
    id: 7,
    logo: LOGO_LIFULL
  },
  {
    id: 8,
    logo: LOGO_TRANSCOSMOS
  },
  {
    id: 9,
    logo: LOGO_YOSHINO
  },
  {
    id: 10,
    logo: LOGO_KEGNEL
  },

  {
    id: 11,
    logo: LOGO_SHIFT_ASIA
  },

  {
    id: 12,
    logo: LOGO_KAO
  }
]
